import React, { useState, useEffect } from "react";

import mysong from "../other-assets/sotd/hang_em_high_mcr.mp3";



function AudioPlayer() {

    const [audioPlaying, setAudioPlaying] = useState(false);
    const [audio] = useState(new Audio(mysong));

    const handleAudioPlayer = () =>{
        if (audioPlaying == false){
          setAudioPlaying(true);
          audio.volume = 0.4;
          audio.play();
          }
        else if (audioPlaying == true) {
          setAudioPlaying(false);
          audio.pause();
        }
        else {
          console.log('error');
        }
      }

    return (
      <div className="music-player-box">
        <div className = 'music-player-container-1'>
            <div className='music-player-details'> Song of the Week </div>
            <div className='music-player-details' id="sotw-subheading"> ⋆˚࿔  9/26/2026  ࿔˚⋆</div>
        </div>
        <div className = 'music-player-container-2'>
            <div className='music-player-details'> Hang 'Em High </div>
            <div id='music-player-mechanics'> 
            <button onClick={() => handleAudioPlayer()}>
                <i class={audioPlaying ? "fa-solid fa-pause" : "fa-solid fa-play"}></i>
                </button>
            
            </div>
        </div>
        </div>
    );
  }

  export default AudioPlayer;